import { Suspense, useMemo } from "react";
import { useDataFetch } from "../../../hooks/useDataFetch2";
import { useColumns } from "../utils/columnsComportamiento";
import { Box, Paper } from "@mui/material";
import Tabla from "../../../components/ui/materialui/serverSideTable";
import TableHeader from "../../../components/ui/materialui/tableHeader";
import MButton from "../../../components/inputs/yup/materialui/mButton";
import { exportExcel } from "../../../utils/exportExcel";
import SummarizeTwoToneIcon from '@mui/icons-material/SummarizeTwoTone';
import { PermissionGuard } from "../../../components/auth/ProtectedRoute";
import { TipoFuncionalidad } from "../../../utils/enums";



interface IProps {
    idMutuo: number;
}

function ComportamientoPago({ idMutuo }: IProps) {
    const urlTabla = 'siscred-api-cartera-total/v1/comportamiento/listar';

    const controlTabla = useDataFetch(
        urlTabla,
        new URLSearchParams({ idMutuo: idMutuo.toString() }),
        true,
    )

    const { COLUMNS } = useColumns({ controlTabla });
    const columns = useMemo(() => COLUMNS, [controlTabla]);

    return (
        <>
            <Suspense>
                <Box sx={{ mt: 2 }}>
                    <Paper elevation={3} sx={{ p: 3 }}>
                        <Tabla
                            columns={columns}
                            control={controlTabla}
                            url={urlTabla}
                            titulo={
                                <TableHeader
                                    title=""
                                    control={controlTabla}
                                    buttonExport={
                                        <PermissionGuard permissions={[TipoFuncionalidad.Transversal_exportar]}>
                                            <MButton
                                                type="button"
                                                variant="outlined"
                                                onClick={() => exportExcel(controlTabla.data, columns, "Comportamiento de Pago")}
                                                startIcon={<SummarizeTwoToneIcon />}
                                            >
                                                Exportar
                                            </MButton>
                                        </PermissionGuard>
                                    }
                                />
                            }
                        />
                    </Paper>
                </Box>
            </Suspense>
        </>
    );
}

export default ComportamientoPago;